import { useState, useEffect, useRef } from 'react';
import Api from '../../../component/Api';

export const useUmsRoute = () => {
    const { http } = Api();
    const httpRef = useRef(http);

    const [umsUrl, setUmsUrl] = useState("#");
    const [isUmsLoading, setIsUmsLoading] = useState(true);
    const hasFetched = useRef(false);

    useEffect(() => {
        httpRef.current = http;
    }, [http]);

    useEffect(() => {
        if (hasFetched.current) return;

        const loadUmsRoute = async () => {
            hasFetched.current = true;
            try {
                const response = await httpRef.current.get("/is/ums/route");
                const data = response?.data;

                if (data?.url) {
                    setUmsUrl(data.url);
                } else {
                    setUmsUrl("#");
                }
            } catch (e) {
                setUmsUrl("#");
            } finally {
                setIsUmsLoading(false);
            }
        };

        loadUmsRoute();
    }, []); 

    const handleClick = () => {
        if (umsUrl !== "#") {
            window.location.href = umsUrl;
        }
    };

    return { umsUrl, handleClick, isUmsLoading };
};